import React from 'react';
import {Link} from 'react-router-dom';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import {FaFacebook} from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';

const {FiMapPin,FiMail,FiPhone,FiExternalLink}=FiIcons;

function Footer() {
  const nycLocations=[
    {borough:'Manhattan',areas:['Upper East Side','Upper West Side','Midtown','Lower East Side','SoHo','Tribeca','Greenwich Village','Chelsea',"Hell's Kitchen",'Financial District']},
    {borough:'Brooklyn',areas:['Williamsburg','DUMBO','Park Slope','Bushwick','Red Hook','Crown Heights','Bed-Stuy','Bay Ridge','Coney Island','Brooklyn Heights']},
    {borough:'Queens',areas:['Long Island City','Astoria','Flushing','Jackson Heights','Forest Hills','Elmhurst','Ridgewood','Bayside','Corona','Woodside']},
    {borough:'The Bronx',areas:['South Bronx','Fordham','Hunts Point','Mott Haven','Concourse','Tremont','Belmont','Morris Heights','Highbridge','Melrose']},
    {borough:'Staten Island',areas:['St. George','Stapleton','New Brighton','Port Richmond','Tottenville','Great Kills','Annadale','Huguenot','Eltingville','Oakwood']}
  ];

  const quickLinks=[
    {name:'Watch Live',path:'/watch'},
    {name:'VOD Library',path:'https://vod.borough.tv/channel/66ddf45007db27257ddb436a/playlist/6706d6bfb42fe49b30fed261/',external:true},
    {name:'Things to Do',path:'/things-to-do'},
    {name:'Weather',path:'/weather'},
    {name:'Blog',path:'https://blog.boroughtv.nyc',external:true}
  ];

  const currentYear=new Date().getFullYear();

  return (
    <footer className="bg-dark-card border-t border-dark-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center space-x-3 mb-6">
              <img src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752863923352-BTV-Logo.png" alt="BoroughTV Logo" className="h-10 w-auto" />
            </Link>
            <p className="text-gray-400 mb-6">
              NYC's digital storytelling platform,amplifying voices from all five boroughs.
            </p>
            <div className="space-y-3 mb-4">
              <div className="flex items-start space-x-3">
                <SafeIcon icon={FiMapPin} className="text-accent-blue mt-1 flex-shrink-0" />
                <div className="text-gray-400">
                  <p>200 Broadway,Floor 3</p>
                  <p>New York,NY 10038</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <SafeIcon icon={FiPhone} className="text-accent-blue mt-1 flex-shrink-0" />
                <div className="text-gray-400">
                  <p>332-378-0003</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <SafeIcon icon={FiMail} className="text-accent-blue mt-1 flex-shrink-0" />
                <div className="text-gray-400">
                  <p>info@boroughtv.nyc</p>
                </div>
              </div>
              <div className="flex items-center space-x-3 mt-4">
                <a href="https://www.facebook.com/BoroughTV/" target="_blank" rel="noopener noreferrer" className="text-accent-blue hover:text-white transition-colors">
                  <FaFacebook className="text-2xl" />
                </a>
              </div>
            </div>
            <div className="mt-4 rounded-lg overflow-hidden border border-dark-border h-48">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d635.7891655882447!2d-74.00930080059098!3d40.71053124832778!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25b1ad87ecbb7%3A0x8241fbe9cf4bd006!2sBoroughTV!5e0!3m2!1sen!2sus!4v1753040195672!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{border:0}}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="BoroughTV Office Location"
              />
            </div>
            <div className="mt-3">
              <a href="https://maps.app.goo.gl/7qocMCVnLHM7nwHH9" target="_blank" rel="noopener noreferrer" className="text-accent-blue hover:underline text-sm flex items-center">
                <span>View on Google Maps</span>
                <SafeIcon icon={FiExternalLink} className="ml-1 text-xs" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-6 text-accent-blue">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link)=>(
                <li key={link.name}>
                  {link.external ? (
                    <a href={link.path} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-accent-blue transition-colors duration-300 flex items-center space-x-2">
                      <span>{link.name}</span>
                      <SafeIcon icon={FiExternalLink} className="text-xs" />
                    </a>
                  ) : (
                    <Link to={link.path} className="text-gray-400 hover:text-accent-blue transition-colors duration-300">
                      {link.name}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h3 className="text-lg font-semibold mb-6 text-accent-blue">Watch BoroughTV Across NYC</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {nycLocations.map((location)=>(
                <div key={location.borough}>
                  <h4 className="font-semibold text-white mb-3">{location.borough}</h4>
                  <ul className="space-y-1">
                    {location.areas.slice(0,6).map((area)=>(
                      <li key={area} className="text-gray-400 text-sm">{area}</li>
                    ))}
                    {location.areas.length>6 && (
                      <li className="text-gray-500 text-sm italic">+{location.areas.length-6} more areas</li>
                    )}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-dark-border mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm">© {currentYear} Nu Interactive Media. All rights reserved.</div>
            <div className="flex items-center space-x-6 text-sm text-gray-400">
              <span>Streaming live from NYC</span>
              <div className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></div>
                <span>Live</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;